<div
  class="cookie-notice"
  data-testid="app-cookie.scope.notice">
  <div class="st-container cookie-notice-container">
    <div class="cookie-notice-text">
      {{
        'We use cookies to improve your online experience and the service we offer. To accept cookies please continue browsing as normal.'
          | translate
      }}
      <a
        href="{{ appConfiguration.website }}/cookie-policy"
        data-testid="app-cookie.action.policy">
        {{ 'Read our cookies policy' | translate }}</a
      >
      {{ 'for more information.' | translate }}
    </div>

    <a
      class="cookie-notice-button"
      data-testid="app-cookie.action.accept"
      href="#"
      (click)="$event.preventDefault(); disableCookieNoticeHandler(appConfiguration.website)">
      <svg
        class="st-stroke-black"
        width="16"
        height="16">
        <use xlink:href="#close"></use>
      </svg>
    </a>
  </div>
</div>
